var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('base-virtual-list',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('object-list-item',{attrs:{"item":item,"actions":_vm.getItemActions(item),"to":_vm.getItemRoute(item)}})]}}],null,false,797693582)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }